/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterDefinitionVolumeSpecification } from './emrClusterDefinitionVolumeSpecification';


export interface EmrClusterDefinitionEbsBlockDeviceConfig { 
    volumeSpecification?: EmrClusterDefinitionVolumeSpecification;
    /**
     * Number of EBS volumes with a specific volume configuration that will be associated with every instance in the instance group                
     */
    volumesPerInstance?: number;
}
